import { render, staticRenderFns } from "./FirstShow.vue?vue&type=template&id=c0f90fb6&scoped=true"
import script from "./FirstShow.vue?vue&type=script&lang=js"
export * from "./FirstShow.vue?vue&type=script&lang=js"
import style0 from "./FirstShow.vue?vue&type=style&index=0&id=c0f90fb6&prod&lang=less&scoped=true"
import style1 from "./FirstShow.vue?vue&type=style&index=1&id=c0f90fb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0f90fb6",
  null
  
)

export default component.exports